import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const FloatingHearts: React.FC = () => {
  // Heart emojis array
  const heartEmojis = ['❤️‍🔥', '💗', '❤️', '🩵', '💘', '💕', '💜', '💖', '💝', '💟', '💓'];
  
  // Generate random hearts for background
  const generateBackgroundHearts = () => {
    const hearts = [];
    for (let i = 0; i < 15; i++) {
      const randomHeart = heartEmojis[Math.floor(Math.random() * heartEmojis.length)];
      const randomDelay = Math.random() * 2;
      const randomDuration = 3 + Math.random() * 4;
      const randomTop = Math.random() * 100;
      const randomLeft = Math.random() * 100;
      const randomSize = 1.5 + Math.random() * 2.5; // Bigger hearts: 1.5rem to 4rem
      
      hearts.push(
        <FloatingHeart
          key={i}
          style={{
            top: `${randomTop}%`,
            left: `${randomLeft}%`,
            fontSize: `${randomSize}rem`,
          }}
          animate={{
            y: [-10, 10, -10],
            rotate: [-5, 5, -5],
            opacity: [0.3, 0.6, 0.3],
          }}
          transition={{
            duration: randomDuration,
            repeat: Infinity,
            delay: randomDelay,
            ease: "easeInOut",
          }}
        >
          {randomHeart}
        </FloatingHeart>
      );
    }
    return hearts;
  };

  return (
    <BackgroundHearts>
      {generateBackgroundHearts()}
    </BackgroundHearts>
  );
};

const BackgroundHearts = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
`;

const FloatingHeart = styled(motion.div)`
  position: absolute;
  user-select: none;
  pointer-events: none;
  opacity: 0.4;
  color: rgba(255, 255, 255, 0.6);
  text-shadow: 0 0 10px rgba(255, 182, 193, 0.5);
`;

export default FloatingHearts; 